import { render, staticRenderFns } from "./moveWaves.vue?vue&type=template&id=a4363d2c&scoped=true&"
import script from "./moveWaves.vue?vue&type=script&lang=js&"
export * from "./moveWaves.vue?vue&type=script&lang=js&"
import style0 from "./moveWaves.vue?vue&type=style&index=0&id=a4363d2c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4363d2c",
  null
  
)

export default component.exports